// eslint-disable-next-line @typescript-eslint/no-explicit-any -- allow argument to be of type any
export function normalizeKey(key) {
    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        key = String(key);
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- disable warning for unsafe return
    return key;
}
export function getKeyPrefix(options, defaultConfig) {
    let keyPrefix = options.name + '/';
    if (options.storeName !== defaultConfig.storeName) {
        keyPrefix += options.storeName + '/';
    }
    return keyPrefix;
}
export function getFullKey(key, keyPrefix) {
    return `${keyPrefix}${key}`;
}
export function executeCallback(promise, callback) {
    if (callback) {
        promise.then(function (result) {
            callback(undefined, result);
        }, function (error) {
            callback(error, undefined);
        });
    }
}
